import React from "react";

// BSU uses Zendesk so this is just a fallback
export default function HelpContent() {
    return (
        <div>
            For help, contact{" "}
            <a href="mailto:FYWPlacement@boisestate.edu">
                FYWPlacement@boisestate.edu
            </a>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/siteConfig/sites/bsu/siteComponents/helpContent.js